import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getTicketRequests } from '../api/ticketRequestApi'
import type { TicketQuery } from '../types'

/**
 * Sayfalı/filtreli/aranabilir bilet talebi listesi. Dil değişince ad'lar için yeniden çeker.
 * {@code keepPreviousData}: filtre/arama/sayfa değişince tablo boşalıp titremez (önceki veri kalır).
 */
export function useTicketRequests(query: TicketQuery) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['ticket-requests', i18n.language, query],
    queryFn: () => getTicketRequests(query),
    placeholderData: keepPreviousData,
  })
}
